import React from "react";
import { Link } from "react-router-dom";
import img1 from "../assets/images/obs-gynae/1.jpg";
import img2 from "../assets/images/obs-gynae/2.avif";

const ObsGynaeSection = () => {
  // 🎨 Luxury Rose-Gold Theme
  const colors = {
    sectionBg: "#F9FBFA", // Logo ke Sage Green ka light version (Fresh & Clinical)
    cardBg: "#FFFFFF", // Pure White
    accent: "#D7A19E", // Logo ka Muted Rose (Feminine & Caring)
    accentSoft: "#FDF4F3", // Logo Rose ka bahut halka tint (Soft Backgrounds ke liye)
    dark: "#546E7A", // Logo ka Dark Slate Blue (Professional & Trust)
    text: "#4A5A64", // Logo blue ka softer variant (Reading ke liye perfect)
    border: "#C5B358",
  };

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #ffffff, #fdf4f6, #ffffff)",
      }}
    >
      {/* ================= SECTION 1 ================= */}
      <section
        className="py-24 px-6"
        style={{ backgroundColor: colors.sectionBg }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Image */}
            <div className="relative">
              <div
                className="absolute -top-8 -left-8 w-full h-full rounded-3xl"
                style={{ backgroundColor: colors.accentSoft }}
              ></div>
              <img
                src={img1}
                alt="Obstetrics Care"
                className="relative rounded-3xl shadow-2xl w-full object-cover"
              />
            </div>

            {/* Content */}
            <div>
              <span
                className="uppercase tracking-widest text-sm font-semibold"
                style={{ color: colors.accent }}
              >
                Women’s Healthcare
              </span>
              <h2
                className="text-4xl lg:text-5xl font-bold mt-4 leading-tight whitespace-nowrap"
                style={{ color: colors.dark }}
              >
                Obstetrics & Gynecology
              </h2>

              <p
                className="mt-6 text-lg leading-relaxed"
                style={{ color: colors.text }}
              >
                we specialize in providing comprehensive women's
                healthcare — from pregnancy and childbirth to advanced
                gynecology treatments. Our team ensures safe, personalized, and
                compassionate care for every stage of a woman's life.
              </p>

              <Link to="/contact-us">
                <button
                  className="mt-8 px-8 py-4 rounded-xl text-white shadow-lg hover:scale-105 transition duration-300"
                  style={{ backgroundColor: colors.accent }}
                >
                  Book Your Consultation
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SECTION 2 ================= */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Content */}
            <div>
              <h3
                className="text-4xl font-bold leading-snug"
                style={{ color: colors.dark }}
              >
                Compassionate Care For Every Stage Of{" "}
                <span style={{ color: colors.accent }}>Womanhood</span>
              </h3>

              <p
                className="mt-6 text-lg leading-relaxed"
                style={{ color: colors.text }}
              >
                Women’s health is a journey that evolves with every phase of
                life — from teenage years to motherhood and menopause. Our OBS &
                GYNAE department ensures the right care at the right time with
                safety, comfort, and emotional support.
              </p>

              {/* Feature Cards */}
              <div className="mt-10 grid sm:grid-cols-2 gap-6">
                {[
                  {
                    title: "Personalized Care Plans",
                    desc: "Individualized treatment paths designed for every woman’s unique needs.",
                  },
                  {
                    title: "Preventive Screenings",
                    desc: "Pap smears, exams & breast health checks for early detection.",
                  },
                  {
                    title: "Comfort & Privacy",
                    desc: "A safe, respectful & supportive consultation environment.",
                  },
                  {
                    title: "Holistic Health",
                    desc: "Guidance on nutrition, stress & long-term wellness.",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="p-6 rounded-2xl shadow-md hover:shadow-xl transition duration-300"
                    style={{
                      backgroundColor: colors.accentSoft,
                      border: `1px solid ${colors.border}`,
                    }}
                  >
                    <h4
                      className="font-semibold mb-2"
                      style={{ color: colors.accent }}
                    >
                      {item.title}
                    </h4>
                    <p
                      className="text-sm leading-relaxed"
                      style={{ color: colors.text }}
                    >
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>

              <Link
                to="/obs-gynae"
                className="inline-block mt-10 px-8 py-4 rounded-xl text-white shadow-lg hover:opacity-90 transition duration-300"
                style={{ backgroundColor: colors.accent }}
              >
                Read More →
              </Link>
            </div>

            {/* Image */}
            <div className="relative">
              <div
                className="absolute -bottom-8 -right-8 w-full h-full rounded-3xl"
                style={{ backgroundColor: colors.accentSoft }}
              ></div>
              <img
                src={img2}
                alt="Family Care"
                className="relative rounded-3xl shadow-2xl w-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ObsGynaeSection;
